import React from 'react';
import PropTypes from 'prop-types';

import Spacing from '@marvelapp/marvel-ui/spacing';

import TickedCopy from 'marketing-website/components/modules/TickedCopy';

const features = [
  {
    id: 0,
    copy: 'Hosted in the EU',
  },
  {
    id: 1,
    copy: 'GDPR Compliant',
  },
  {
    id: 2,
    copy: 'SAML-based SSO',
  },
  {
    id: 3,
    copy: 'IP Restriction and account locking',
  },
  {
    id: 4,
    copy: 'Multi-layer encryption',
  },
  {
    id: 5,
    copy: 'Full range of user permissions',
  },
];

export default function Features({ size }) {
  return (
    <div>
      {features.map(item => (
        <Spacing key={item.id} size="xs" position="topBottom" type="margin">
          <TickedCopy size={size}>{item.copy}</TickedCopy>
        </Spacing>
      ))}
    </div>
  );
}

Features.propTypes = {
  size: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/pages/security/Features.js